import { Component, OnInit } from '@angular/core';
import { UserHeaderComponent } from './user-header/user-header.component';
import { UserAssignmentsComponent } from './user-assignments/user-assignments.component';
import { UserSessionsComponent } from './user-sessions/user-sessions.component';
import { QaiInnerWrapComponent } from '@qai/ui';
import { ActivatedRoute } from '@angular/router';
import { ReportingDashboardService } from 'src/app/services/reporting-dashboard/reporting-dashboard.service';
import { ReportingLocalStorageUtil } from 'src/app/utils/reporting-localstorage.util';
import { LocaleService } from 'src/app/services/locale.service';
import { AmplitudeService } from 'src/app/services/external-tools/amplitude.service';
import { AmplitudeTrackingEvents } from 'src/app/utils/enums/amplitude/amplitudeTrackingEvents.enum';
import { withDemoModule } from 'src/app/utils/demo-mode/demo-mode-context.util';
import { AppConstants } from 'src/app/app-constants';
import { FeatureFlagsService } from 'src/app/services/feature-flags.service';
import { UserHighlightCardsComponent } from './user-highlight-cards/user-highlight-cards.component';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.scss'],
  standalone: true,
  imports: [
    UserHeaderComponent,
    UserAssignmentsComponent,
    UserSessionsComponent,
    QaiInnerWrapComponent,
    UserHighlightCardsComponent
]
})
export class UserDetailsComponent implements OnInit {
  userName: string = '';
  totalAssignments: number = 0;
  totalSessions: number = 0;
  lastLogin: string = '';
  certifiedAssignments: number = 0;
  totalCertificationAssignments: number = 0;
  memberOfTeams: string = '';
  hoursSpentPracticing: number = 0;
  isLoading: boolean = false;
  userUuid: string = '';
  activeTab: string = 'practice';
  showHighlightCards = false;

  constructor(
    private route: ActivatedRoute,
    private reportingService: ReportingDashboardService,
    private localeService: LocaleService,
    private amplitudeService: AmplitudeService,
    private featureFlagsService: FeatureFlagsService
  ) {}

  async ngOnInit(): Promise<void> {
    this.showHighlightCards = await this.featureFlagsService.isFlagEnabled(
      AppConstants.USER_HIGHLIGHTS
    );
    this.amplitudeService.trackEvent(AmplitudeTrackingEvents.USER_DETAIL_PAGE);
    this.route.paramMap.subscribe((params) => {
      const userId = params.get('id');
      if (userId) {
        this.userUuid = userId;
        this.loadUserData(userId);
      }
    });
  }

  onTabChangedFromUserAssignments(tabId: string): void {
    this.activeTab = tabId;
  }

  private loadUserData(userUuid: string): void {
    const accountUuid = ReportingLocalStorageUtil.getStoredAccountUuid();

    if (!accountUuid) {
      console.error('No accountUuid found in localStorage');
      return;
    }

    this.isLoading = true;
    this.reportingService.getUserSummary({ accountUuid, userUuid}, withDemoModule(AppConstants.NEW_REPORTING_UI)).subscribe({
      next: (response) => {
        this.userName = response.name;
        this.totalAssignments = response.totalAssignments;
        this.totalSessions = response.totalSessions;
        this.lastLogin = this.localeService.formatDate(response.lastLoginDate);
        this.certifiedAssignments = response.certifiedAssignments;
        this.totalCertificationAssignments = response.totalCertificationAssignments;
        this.memberOfTeams = response.memberOfTeams;
        this.hoursSpentPracticing = response.hoursSpentPracticing;
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Failed to load user summary data:', error);
        this.isLoading = false;
      }
    });
  }
}
